export default __webpack_public_path__ + "static/media/domains.e9a53abc.jpg";